/**
* lr JS
* -----------------------------------------------------------------------------
*
* All the JS for the lr component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'lr',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.lr' ).each( ( i, el ) => {
        gsap.to( $( el ).find( '.lr__image' ), {
          '--y': '-1.25rem',
          '--xLeft': '-1.25rem',
          '--xRight': '1.25rem',
          'scrollTrigger': {
            trigger: el,
            scrub: 1,
            start: 'top 75%',
            end: 'bottom 75%',
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'lr', COMPONENT );
} )( app );
